import React from "react";
import { Link } from "react-router-dom"
import { Nav } from "react-bootstrap";

import Navbar from "react-bootstrap/Navbar";

function Menu({colorScheme}) {
  return (
      <Navbar collapseOnSelect expand="md" variant={colorScheme} style={{fontSize: 30, zIndex: 5}}>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" >
          <Nav style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly'}}>
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/wordhunt">WordHunt</Nav.Link>
            <Nav.Link as={Link} to="/wordbites">WordBites</Nav.Link>
            <Nav.Link as={Link} to="/anagrams">Anagrams</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
  );
}

export default Menu;
